const PlansRestrictions = {
  FREEMIUM: { clientsCount: 20, suivisCount: 10000 },
  PREMIUM: { clientsCount: 1000, suivisCount: 10000 },
};

export default PlansRestrictions;
